import React from 'react';
import Dropzone from 'react-dropzone';
import { Box, Typography, Stack, Avatar, SvgIcon } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

interface FileUploadProps {
  onDrop: Function;
  caption?: string;
  accept?: string;
  maxSize?: number;
  capture?: boolean | 'user' | 'environment';
}

const FileUpload: React.FC<FileUploadProps> = ({
  onDrop,
  caption,
  accept = 'image/png',
  maxSize = 1000000,
  capture,
}) => {
  return (
    //@ts-ignore
    <Dropzone onDrop={onDrop} accept={accept} maxSize={maxSize}>
      {({ getRootProps, getInputProps }) => {
        const inputProps = getInputProps();

        // For mobile camera capture, we need to handle the input differently
        if (capture !== undefined) {
          // Override the input props to ensure proper file handling
          const originalOnChange = inputProps.onChange;
          inputProps.capture = capture;
          inputProps.onChange = (e: any) => {
            console.log('File input change event:', e);
            console.log('Files from input:', e.target.files);

            // Manually handle the file upload to ensure proper File objects
            if (e.target.files && e.target.files.length > 0) {
              const files = Array.from(e.target.files) as File[];
              console.log('Files array:', files);
              files.forEach((file, i) => {
                console.log(`File ${i}:`, {
                  name: file.name,
                  type: file.type,
                  size: file.size,
                  isFile: file instanceof File,
                  isBlob: file instanceof Blob,
                });
              });

              // Call the onDrop handler directly with proper File objects
              if (files.length > 0) {
                onDrop(files);
                return;
              }
            }

            // Fallback to original handler
            if (originalOnChange) {
              originalOnChange(e);
            }
          };
        }

        return (
          <Box
            sx={{
              alignItems: 'center',
              border: 1,
              borderRadius: 1,
              borderStyle: 'dashed',
              borderColor: 'divider',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              outline: 'none',
              p: 6,
              '&:hover': {
                backgroundColor: 'action.hover',
                cursor: 'pointer',
                opacity: 0.5,
              },
            }}
            {...getRootProps()}
          >
            <input {...inputProps} />
          <Stack alignItems="center" direction="row" spacing={2}>
            <Avatar
              sx={{
                height: 64,
                width: 64,
              }}
            >
              <SvgIcon>
                <FileUploadOutlinedIcon />
              </SvgIcon>
            </Avatar>
            <Stack spacing={1}>
              <Typography
                sx={{
                  '& span': {
                    textDecoration: 'underline',
                  },
                }}
                variant="h6"
              >
                <span>Click to upload</span> or drag and drop
              </Typography>
              {caption && (
                <Typography color="text.secondary" variant="body2">
                  {caption}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Box>
        );
      }}
    </Dropzone>
  );
};

export default FileUpload;
